import { Controller } from "@hotwired/stimulus";
import Logger from "../lib/logger";
class default_1 extends Controller {
    connect() {
        Logger.debug("Expandable container connected", {
            hasContainer: this.hasContainerTarget,
            hasButton: this.hasButtonTextTarget,
            scrollOnExpand: this.scrollOnExpandValue
        });
    }
    disconnect() {
        if (this.scrollTimeout) {
            window.clearTimeout(this.scrollTimeout);
        }
    }
    toggle(event) {
        event.preventDefault();
        // Check state from the first container
        const isExpanded = this.containerTargets.length > 0 && this.containerTargets[0].style.maxHeight !== "";
        Logger.debug("Toggle clicked", { isExpanded });
        if (isExpanded) {
            // Collapse
            this.containerTargets.forEach(container => container.style.maxHeight = "");
            if (this.hasButtonTextTarget)
                this.buttonTextTarget.textContent = "Expand";
            if (this.hasIconTarget)
                this.iconTarget.className = "fas fa-expand-arrows-alt me-1";
        }
        else {
            // Expand
            this.containerTargets.forEach(container => container.style.maxHeight = "75vh");
            if (this.hasButtonTextTarget)
                this.buttonTextTarget.textContent = "Collapse";
            if (this.hasIconTarget)
                this.iconTarget.className = "fas fa-compress-arrows-alt me-1";
            if (this.scrollOnExpandValue) {
                // Scroll into view to move focus to the expanded card
                this.scrollTimeout = window.setTimeout(() => {
                    const offset = 80; // Offset for fixed navbar
                    const elementPosition = this.element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.scrollY - offset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }, 150);
            }
        }
    }
}
default_1.targets = ["container", "buttonText", "icon"];
default_1.values = {
    scrollOnExpand: { type: Boolean, default: false }
};
export default default_1;
